import React, { useState, useEffect } from "react";
import { Link as RouterLink, useLocation, useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import { onAuthUIStateChange } from "@aws-amplify/ui-components";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DataStore } from "@aws-amplify/datastore";
import { Users } from "models";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0.5),
  },
  title: {
    flexGrow: 1,
  },
}));

function Navbar() {
  const classes = useStyles();
  const loc = useLocation();
  const [name, setName] = useState();
  const [school, setSchool] = useState();
  const history = useHistory();
  useEffect(() => {
    // remove missing rows
    
    async function getUserInfo() {
      const user = await Auth.currentAuthenticatedUser();
      // const users = await DataStore.query(Users);
      // console.log('users', users);
      const users = await DataStore.query(Users, (d) =>
        d.email("eq", user.attributes.email)
      );
      setName(user.attributes.name);
      const school = users[0].school;
      setSchool(school);
      console.log(user.attributes.name);
      console.log(users);
      // if (users[0].school){
      //   const school = users[0].school;

      //   setSchool(school);
      // }

      // console.log("user,school", user, user.attributes.name, school);
    }

    async function load() {
      // filter by the user's school
      try {
        getUserInfo();
      } catch (err) {
        console.log(err.message);
      }
    }
    load()

    return onAuthUIStateChange(async (nextAuthState, authData) => {
      console.log("auth change", nextAuthState, authData);

      if (nextAuthState === "signedin") {
        console.log("calling");
        history.push("/");
        getUserInfo();
      } else {
        // console.log('stop', DataStore);
        // await DataStore.stop();
        // await DataStore.clear();
        // await DataStore.start();
        // console.log('start');
      }
    });
  }, []);

  return (
    <AppBar className={classes.root} position="static" color="inherit">
      <Toolbar variant="dense">
        <Link
          // variant="h6"
          className={classes.title}
          // underline="none"
          color="inherit"
          component={RouterLink}
          to="/"
        >
          <img
            src={process.env.PUBLIC_URL + "/assets/bmr_logo.png"}
            height="42px"
            width="42px"
          />
        </Link>

        <Button
          color={loc.pathname === "/eyepiece1" ? "primary" : "inherit"}
          component={RouterLink}
          to="/eyepiece1"
          startIcon={
            loc.pathname === "/eyepiece1" && <VisibilityIcon color="primary" />
          }
        >
          <Typography variant="button">Eyepiece 1</Typography>
        </Button>
        <Button
          color={loc.pathname === "/eyepiece2" ? "primary" : "inherit"}
          component={RouterLink}
          to="/eyepiece2"
          startIcon={
            loc.pathname === "/eyepiece2" && <VisibilityIcon color="primary" />
          }
        >
          <Typography variant="button">Eyepiece 2</Typography>
        </Button>
        <Button
          color={loc.pathname === "/eyepiece3" ? "primary" : "inherit"}
          component={RouterLink}
          to="/eyepiece3"
          startIcon={
            loc.pathname === "/eyepiece3" && <VisibilityIcon color="primary" />
          }
        >
          <Typography variant="button">Eyepiece 3</Typography>
        </Button>
        <Button color="inherit" onClick={() => Auth.signOut()}>
          Sign Out
        </Button>
        <Box
          display="flex"
          alignItems="center"
          color="#757575"
          marginLeft="10px"
        >
          <AccountCircleIcon />
          &nbsp;
          <Typography variant="button">{`${name}`}</Typography>
          &nbsp;
          <Typography variant="overline">{`(${school})`}</Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
